import { Button } from "@/components/atoms/buttons/Button";
import {
  Modal,
  ModalFoot,
  ModalHead,
  Sizes,
} from "@/components/molecules/modals/Modal";
import { ServiceUnDeletableMessage } from "./ServiceUnDeletableMessage";

interface Props {
  isOpen: boolean;
  close: () => void;
}

export default function ServiceUnDeletableModal({ isOpen, close }: Props) {
  return (
    <Modal isOpen={isOpen} handleClose={close} size={Sizes.SS}>
      <ModalHead title="サービス削除" onClickClose={close} />
      <div className="p-4">
        <p>
          <ServiceUnDeletableMessage />
        </p>
      </div>
      <ModalFoot className="space-x-4">
        <Button
          size="sm"
          spSize="md"
          onClick={close}
          color="cancel"
          label="閉じる"
        />
      </ModalFoot>
    </Modal>
  );
}
